export default __webpack_public_path__ + "static/media/Linero1Open.daf96027.jpg";